import { clientSideMetrics } from '@marketplace-web/observability/client-metrics-util'
import { MS_PER_SECOND } from '@marketplace-web/shared/utils'

const CONVERSATION_LIST_LOAD_METRIC_NAME = 'frontend_conversation_list_load_count'
const CONVERSATION_LIST_LOAD_DURATION_METRIC_NAME = 'frontend_conversation_list_load_duration'
const CONVERSATION_LOAD_METRIC_NAME = 'frontend_conversation_load_count'
const CONVERSATION_LOAD_DURATION_METRIC_NAME = 'frontend_conversation_load_duration'
const BUCKETS = [0.05, 0.2, 0.4, 0.8, 1.2, 1.6, 2, 3.5, 5, 8, 10]

export const incrementConversationListLoad = (state: 'success' | 'failure') => {
  clientSideMetrics.counter(CONVERSATION_LIST_LOAD_METRIC_NAME, { state }).increment()
}

export const observeConversationListLoadTime = (state: 'success' | 'failure', loadTime: number) => {
  clientSideMetrics
    .histogram(CONVERSATION_LIST_LOAD_DURATION_METRIC_NAME, { state }, BUCKETS)
    .observe(loadTime / MS_PER_SECOND)
}

export const incrementConversationLoad = (state: 'success' | 'failure') => {
  clientSideMetrics.counter(CONVERSATION_LOAD_METRIC_NAME, { state }).increment()
}

export const observeConversationLoadTime = (state: 'success' | 'failure', loadTime: number) => {
  clientSideMetrics
    .histogram(CONVERSATION_LOAD_DURATION_METRIC_NAME, { state }, BUCKETS)
    .observe(loadTime / MS_PER_SECOND)
}
